export default class EventEmitter{
  constructor(){
    this.listeners = {};
    this.EVENT_TYPES = {
      WS_REQ: 'wsrq',
      WS_ONLINE_STATE: 'wso',
      BIKES: 'bikes',
      GET_RIDE : 'getride',
      ON_NEW_RIDE : 'onnewride',
      GETPATH : "getPath",
      RIDE_DATA : 'rideData',
      ON_NEW_NOTIF: "newNotif",
      VEHSTAT: "vehstat",
      ON_CHANGE_VEHSTAT: "ChangeVehStat",
      CHANGE_GET_RIDE_EVENT: "changeGetRideEvent",
      SUB_VEH: 'subVeh',
      ON_TIMELINE_EVENTS: 'onTimelineEvents',  // when events load from server
      GET_EVENTS_BY_LIMIT: "getEventsByLimit",
      EVENTS_SAVED_IN_DB: "eventsSavedInDB",
      LOCATION_EVENTS: "loc_event",
      PSEUDO_PROCESSED: "pseudoEvtProcessed",
      GET_LOC_FOR_DAY: "getLocForDay",
      SAVED_LOC_FOR_DAY: "savedLocForDay",
      ON_LATEST_EVENT: "onLatestEvt",
      REMOVE_LOC_LISTENER: "removeLocListener",
      NEW_NOTIF: "latestNotif",
      MENU_CHANGE: "menuChange"
    }
  }

  addEventListener(eventName, func){
    if(typeof func !== 'function') return;

    if(!this.listeners[eventName]){
      this.listeners[eventName] = [];
    }
    else if(this.listeners[eventName].indexOf(func) >= 0)
      return;
    this.listeners[eventName].push(func);
  }

  removeEventListener(eventName, func){
    if(typeof func !== 'function') return;

    if(func && this.listeners[eventName]){
      var index = this.listeners[eventName].indexOf(func);
      if(index >= 0) this.listeners[eventName].splice(index, 1);
    }
  }

  removeAllListeners(eventName){
    delete this.listeners[eventName]
  }

  emitEvent(eventName, ...args){
    if(this.listeners[eventName])
      this.listeners[eventName].forEach((el)=>{
        el(...args);
      });
  }
}
